// extracted by mini-css-extract-plugin
export default {"commentBox":"ShowMoreSidePanel_commentBox__LucMi"};